import { render, staticRenderFns } from "./EditAssignmentMenu.vue?vue&type=template&id=d386d884&scoped=true"
import script from "./EditAssignmentMenu.vue?vue&type=script&lang=js"
export * from "./EditAssignmentMenu.vue?vue&type=script&lang=js"
import style0 from "./EditAssignmentMenu.vue?vue&type=style&index=0&id=d386d884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d386d884",
  null
  
)

export default component.exports